<template>
    <!-- Componente para mostrar el botón para descargar la tabla de amortización sin necesidad de llenar el formulario de aplics cuando el modelo tiene Click to buy -->
    <div>
        <button
            class="w-56 xs:w-68 sm:w-88 hyundai-button sm:text-base mx-auto mt-8"
            :class="showLoader ? 'opacity-75 cursor-default' : ''"
            :disabled="showLoader"
            @click="sendBbvaData()"
        >
            {{ showLoader ? "Cargando..." : "Descarga tu Tabla de Pagos (Amortización)" }}
        </button>
        <!-- <a
            id="download-table"
            :href="urlPDF"
            class="hidden"
            download
        >Descargar</a> -->
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import moment from "moment";

export default {
    props: [
        "subName",
        "modelName",
        "versionId",
        "versionName",
        "versionPrice",
        "modelYear",
        "term",
        "pagoMensual",
        "montoTotal",
        "totalPagar",
        "enganche",
        "seguro",
        "bbvaAppId",
    ],
    data() {
        return {
            url: $(".url").text(),
            // Variable para determinar si mostrar el mensaje
            // de cargando
            showLoader: false,
            // Variable para almacenar la url para descargar el PDF
            urlPDF: "",
            // Variable para almacenar una instancia de JsPDF para
            // generar el pdf de la tabla de amortización
            docPdf: new jsPDF({
                format: "letter",
            }),
            // Variable para almacenar la cotización de BBVA
            bbvaQuotation: {},
            // Variable para almacenar el folio de la cotización
            quotFolio: "",
        };
    },
    watch: {
        // Observa la variable showLoader para emitir el evento
        // cuando se está cargando la tabla de amortización
        showLoader: function (val) {
            this.$emit("loading", val);
        },
    },
    methods: {
        // Función para dar formato a los precios
        formatPrice(price) {
            return (
                "$" +
                parseFloat(price)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            );
        },
        // Función para mostrar una alerta de error
        swalError() {
            Swal.fire({
                icon: "error",
                title: '<h3 class="text-2xl leading-tight font-medium">Hubo un problema al procesar tu solicitud</h3>',
                html: "<p>Intentalo de nuevo más tarde</p>",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
                didClose: () => {
                    this.showLoader = false;
                },
            });
        },
        // Función para enviar la información de la cotización
        // para obtener los datos del plazo seleccionado y
        // generar la tabla de amortización
        sendBbvaData() {
            if (!this.urlPDF) {
                this.showLoader = true;
                // Petición para calcular la cotización
                axios
                    .post(`${this.url}/bbva/calcular-cotizacion`, {
                        pt_id: this.versionId,
                        enganche: this.enganche,
                        year: this.modelYear,
                        plan_term: this.term,
                        seguro: this.seguro === "insu" ? true : false,
                    })
                    .then((resp) => {
                        console.log("/bbva/calcular-cotizacion form-resp", resp);
                        if (resp.data.success) {
                            this.bbvaQuotation = resp.data.data;
                            this.bbvaQuotation.bbva_quotation_id = resp.data.bbva_quotation_id;
                            // Petición para enlazar la cotización obtenida
                            axios
                                .post(`${this.url}/cotizadores/enlazar-cotizacion`, {
                                    aplics_form_id: "0",
                                    from_cetelem: 0,
                                    casualtyInsurance: this.seguro === "insu",
                                    downPayment: this.enganche,
                                    number: this.term,
                                    year: this.modelYear,
                                    marketValue: this.versionPrice,
                                    vehicle_id: this.versionId,
                                    bbva_api_call_id: this.bbvaQuotation.bbva_quotation_id,
                                    bbva_app_id: this.bbvaAppId,
                                })
                                .then((resp) => {
                                    console.log("/cotizadores/enlazar-cotizacion form-resp", resp);
                                    if (resp.data.success) {
                                        this.quotFolio = resp.data.bbva_folio;
                                        this.createPDF();
                                    } else {
                                        this.swalError();
                                    }
                                })
                                .catch((error) => {
                                    if (error.response) {
                                        // Request made and server responded
                                        console.log("error.response", error.response.data);
                                    } else if (error.request) {
                                        // The request was made but no response was received
                                        console.log("error.request", error.request);
                                    } else {
                                        // Something happened in setting up the request that triggered an Error
                                        console.log("error.message", error.message);
                                    }
                                    this.swalError();
                                });
                        } else {
                            this.swalError();
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            // Request made and server responded
                            console.log(error.response.data);
                        } else if (error.request) {
                            // The request was made but no response was received
                            console.log(error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log("Error", error.message);
                        }
                        this.swalError();
                    });
            } else {
                this.downloadQuotation();
            }
        },
        // Función para crear el pdf de la tabla de amortización
        createPDF() {
            let pageWidth = this.docPdf.internal.pageSize.getWidth();
            this.docPdf.text("Tabla de Amortización BBVA Consumer Finance", pageWidth / 2, 20, { align: "center" });
            this.docPdf.text("FECHA DE EMISIÓN: " + moment().format("DD/MM/YYYY"), pageWidth / 2, 30, {
                align: "center",
            });
            this.docPdf.text(this.modelName + " " + this.modelYear, pageWidth / 2, 40, { align: "center" });

            this.docPdf.setFontSize(13);
            this.docPdf.text("Monto del Préstamo: " + this.formatPrice(this.requestedAmount), 20, 60);
            this.docPdf.text("Enganche: " + this.formatPrice(this.enganche), 120, 60);
            this.docPdf.line(15, 65, 200, 65, "F");

            this.docPdf.text("Plazo: " + this.term, 20, 75);
            this.docPdf.text("Comisión de Apertura (4): " + this.formatPrice(this.openFee), 120, 75);

            this.docPdf.text("Pago Mensual (1): " + this.formatPrice(this.installmentAmount), 20, 85);
            this.docPdf.text("Seguro de Auto: " + this.formatPrice(this.casualtyInsurance), 120, 85);

            this.docPdf.text("Tasa de Interés (2): " + this.nominalFeePercentage + "%", 20, 95);
            this.docPdf.text("Seguro de Vida: " + this.formatPrice(this.lifeInsurance), 120, 95);

            this.docPdf.text("CAT (3): " + this.annualPercentageRate + "%", 20, 105);
            this.docPdf.text("Monto Total a Pagar: " + this.formatPrice(this.totalAmount), 120, 105);

            this.docPdf.setFontSize(12);
            this.docPdf.text("1 Pago mensual sin IVA.", 20, 125);

            this.docPdf.text("2", 20, 130);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text("Tasa Fija de Interés Anual.", 24, 130);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`3`, 20, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`CAT ${this.annualPercentageRate}%`, 24, 135);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`"Sin IVA" informativo.`, 48, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`Fecha de cálculo: `, 90, 135);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`${moment().format("DD/MM/YYYY")}.`, 127, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`Vigencia de la oferta: `, 20, 140);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`${moment().format("DD/MM/YYYY")}.`, 64, 140);

            this.docPdf.text(
                "4 Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio).",
                20,
                145
            );
            this.docPdf.text("Aplican Restricciones.", 20, 150);
            this.docPdf.text("Las cantidades presentadas en esta tabla se encuentran en pesos méxicanos.", 20, 155);

            if (this.seguro === "noInsu") {
                this.docPdf.text(
                    "La Tabla de Amortización no considera el seguro de daños, este deberá cotizarse y",
                    20,
                    165
                );
                this.docPdf.text("dependiendo de la forma de pago, podrá modificar los datos aquí asentados.", 20, 170);
            }
            this.docPdf.text(
                "Este documento es para efectos informativos y no constituye obligación y ofrecimiento",
                20,
                175
            );
            this.docPdf.text("formal por parte de BBVA Bancomer, S.A. en el otorgamiento del Crédito.", 20, 180);
            this.docPdf.text("Las condiciones de los Créditos estarán sujetas a cambios sin previo aviso.", 20, 185);

            this.docPdf.autoTable({
                startY: 200,
                // margin: { top: 180 },
                // pageBreak: 'auto',
                head: [
                    [
                        "Núm. Periodo",
                        "Saldo Insoluto Auto",
                        "Prima Seguro Daños con IVA",
                        "Prima Seguro Vida con IVA",
                        "Pago Mensual Capital Auto",
                        "Pago Mensual Intereses Auto",
                        "IVA Intereses Auto",
                        "Pago Total con IVA",
                    ],
                ],
                body: this.tableRows,
                // didDrawCell: (HookData) => {
                //     tableHeight += HookData.row.height
                // }
            });

            /* se hace el envio del archivo para poderlo guardar dentro del servidor */
            var blob = this.docPdf.output("blob");
            var formData = new FormData();

            let fileName = `Tabla de amortización BBVA - ${this.quotFolio}.pdf`;

            formData.append("pdf", blob);
            formData.append("file_name", fileName);

            // Petición para guardar el pdf de la tabla de amortización generada
            axios
                .post(`${this.url}/bbva/save-pdf`, formData)
                .then((resp) => {
                    console.log("/bbva/save-pdf", resp);
                    this.urlPDF = this.url + "/storage/bbva/" + fileName;
                    this.showLoader = false;
                    this.downloadQuotation();
                })
                .catch((error) => {
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                    this.swalError();
                });
        },
        // Función para descargar la tabla de amortización generada
        downloadQuotation() {
            this.docPdf.save(`Tabla de amortización BBVA - ${this.quotFolio}.pdf`);
            // window.open(this.urlPDF, "_blank");
            // window.location = this.urlPDF;
        },
    },
    computed: {
        // momentDate() {
        //     return moment();
        // },
        // Variables computadas para la tabla de amortización
        requestedAmount() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].requestedAmount.amount : 0;
        },
        totalAmount() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].totalAmount.amount : 0;
        },
        openFee() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].fees.itemizeFees[0].feeAmount.amount
                : 0;
        },
        installmentAmount() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].installmentPlan.installmentAmount.amount
                : 0;
        },
        casualtyInsurance() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].additionalProducts[0].amount
                : 0;
        },
        nominalFeePercentage() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].rates[0].unit.percentage : 0;
        },
        annualPercentageRate() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].rates[1].unit.percentage : 0;
        },
        lifeInsurance() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].additionalProducts[1].amount
                : 0;
        },
        // Retorna los datos de las filas para la tabla de amortización
        tableRows() {
            let tableRows = [];
            if (this.bbvaQuotation.installments) {
                this.bbvaQuotation.installments[0].installmentPlan.scheduledPayments.forEach((payment) => {
                    tableRows.push([
                        payment.number,
                        this.formatPrice(payment.remaining.principal.amount),
                        this.formatPrice(payment.remaining.additionalData[0].amount),
                        this.formatPrice(payment.remaining.additionalData[1].amount),
                        this.formatPrice(payment.principal.amount),
                        this.formatPrice(payment.interest.amount),
                        this.formatPrice(payment.tax.amount),
                        this.formatPrice(payment.total.amount),
                    ]);
                });
            }
            return tableRows;
        },
    },
    mounted() {
        this.$eventBus.$on("includeInsuranceChanged", () => {
            this.urlPDF = "";
            this.docPdf = new jsPDF({
                format: "letter",
            });
        });
    },
};
</script>

<style></style>
